import {getRequest} from '@/framework/utils/request'
const request = getRequest('common')

export function getMenu() {
  return request({
    url: process.env.VUE_APP_BASE_API + '/permission/menus',
    method: 'get'
  })
}

export function getOperation() {
  return request({
    url: process.env.VUE_APP_BASE_API + '/permission/operations'
  })
}
